import { render, staticRenderFns } from "./seatDialog.vue?vue&type=template&id=4bd37225&"
import script from "./seatDialog.vue?vue&type=script&lang=js&"
export * from "./seatDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports